<div *ngIf="integrationType !== 'disabled'" class="itb-integration-box {{integrationType}}" (click)="onAddClickEvent(integrationType, integrationLogo)">
    <img *ngIf="integrationType==='added'" src="images-library/{{integrationLogo}}.png" >
    <img *ngIf="integrationType==='add'" src="images-library/{{integrationLogo}}_disabled.png">    
</div>

<div *ngIf="integrationType === 'disabled'" class="itb-integration-box {{integrationType}}">
    <img *ngIf="integrationType==='disabled'" src="images-library/{{integrationLogo}}_disabled.png">    
</div>
